import { styled } from '@linaria/react';

export const RecommendationsWrapper = styled.div`
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
`;
